import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

import RatingBar from './RatingBar';

const ICON_SIZE = '48px';

export default function BreedTraitCard({
  category,
  className,
  description,
  icon,
  rating
}) {
  return (
    <div
      className={classnames(
        'BreedDescriptionCard flex flex-column flex-auto bg-grayish-blue ph10 pv10 f4 font-serif midnight tc',
        className
      )}
      style={{ minHeight: '220px' }}
    >
      {icon && (
        <Icon
          className="self-center dark-gray mb4"
          name={icon}
          width={ICON_SIZE}
          height={ICON_SIZE}
        />
      )}
      <p className="flex flex-auto justify-center items-center f6 f8-xl lh-title break-word">
        {description}
      </p>
      <div className="mt4">
        {rating ? (
          <RatingBar title={category} rating={rating} />
        ) : (
          <p className="f3 f4-xl dark-gray">{category}</p>
        )}
      </div>
    </div>
  );
}

BreedTraitCard.propTypes = {
  category: PropTypes.string.isRequired,
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  rating: PropTypes.number
};

BreedTraitCard.defaultProps = {
  className: null,
  icon: null,
  rating: null
};
